import { render, staticRenderFns } from "./ToWin.vue?vue&type=template&id=b3ec32b2&scoped=true&"
import script from "./ToWin.vue?vue&type=script&lang=ts&"
export * from "./ToWin.vue?vue&type=script&lang=ts&"
import style0 from "./ToWin.vue?vue&type=style&index=0&id=b3ec32b2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ec32b2",
  null
  
)

export default component.exports